import { render, staticRenderFns } from "./ClonarDialog.vue?vue&type=template&id=a6a33d30&scoped=true&lang=pug"
import script from "./ClonarDialog.vue?vue&type=script&lang=js"
export * from "./ClonarDialog.vue?vue&type=script&lang=js"
import style0 from "./ClonarDialog.vue?vue&type=style&index=0&id=a6a33d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a33d30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VIcon,VSelect})
